import { useGetExaminationInfoHooks } from 'hooks/u002/useGetExaminationInfoHooks';
import LoadingModal from 'organisms/LoadingModal';
import {
  AuditionFormRouteContext,
  AuditionTopPage,
  GetAuditionContext,
} from 'pages/AuditionFormTop';
import { FC, useContext } from 'react';
import { QuestionnaireForm } from './QuestionnaireForm';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';

/**
 * ログイン済みの場合のアンケート画面
 *
 */
export const AuthenticatedQuestionnaire: FC = () => {
  const { audition_id, examination_no } = useContext(AuditionFormRouteContext);
  const { title } = useContext(GetAuditionContext);
  const { t } = useTranslationWithLang('auditionForm');
  // 2-2.API「U002A31 アンケート参加状況確認」を実行し、応募者がアンケート回答権限を保持しているかの情報を取得する。
  const [examinationInfo, isLoading] = useGetExaminationInfoHooks({
    audition_id,
    examination_no,
  });

  if (isLoading) {
    return <LoadingModal />;
  }
  if (examinationInfo == null) {
    return <></>;
  }
  // 2-3.APIの結果、statusが"01"だった場合、アンケート参加不可のため文言を表示し、ボタン類を非表示にする。
  if (examinationInfo.status === '01') {
    return <AuditionTopPage title={title}>{t('TU002_121')}</AuditionTopPage>;
  }

  // 2-4.APIの結果、statusが"00"だった場合、アンケートへの参加のため、U002F18-00 初期表示を実行し、応募フォーム画面へ遷移する。
  return <QuestionnaireForm />;
};
